import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../shared';


/**
* Component of the MNSA table of PDF print.
*/
@Component({
	selector: 'prt-mnsa-table',
	templateUrl: './prt-mnsa-table.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PrtMnsaTableComponent extends BaseComponent implements OnInit {

	/**
	 * MNSA value.
	 */
	mnsa?: number;
	/**
	 * Correction MNSA value.
	 */
	desideredMNSA?: number;
	/**
	 * Difference between MNSA and desired value.
	 */
	difference?: number;


	ngOnInit(): void {
		this.mnsa = this.canvasSrv.defAPMeasures!.def_ap_MNSA ?? 0;
		this.desideredMNSA = this.eocMeasures!.eoc_ap_MNSA ?? 0;
		this.difference = this.mnsa - this.desideredMNSA;
	}

}
